export default __webpack_public_path__ + "static/media/dejan_s.c7c02a64.jpg";